/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import logo from '../../Recursos/logo_blanco.svg'
import {DIRECCIONLOCALES, SECCIONES} from "../../Constantes";
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {useNavigate} from "react-router-dom";
import {useMenuPop} from "../../Modulo_Menu_Pop/Hooks/useMenuPop";
import {iniciarChatWass} from "../../Utilidades/iniciarChatWass";
import {useCarritoFlotante} from "../../Modulo_Carrito_Flotante/Hooks/useCarritoFlotante";
import {useProductosCarrito} from "../../Modulo_Carrito_Flotante/Funcionamiento/Hooks/useProductosCarrito";
import iso from '../../Recursos/iso_azul.svg'
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Formulario_Interactivo from "../Dialogos/Dialogo_Formulario_Interactivo";


const BarraPc = () => {
    const {Dialogo, abrir: abrirDialogo} = useDialogo({
        Componente: Dialogo_Formulario_Interactivo,
        titulo: 'Pre-Inscripcion'
    })
    const {ir} = useIrRuta({funcionUno: abrirDialogo})
    const navigate = useNavigate();
    const {MenuPop, abrirMenu} = useMenuPop()
    const {Carrito, abrir} = useCarritoFlotante()
    const {productos} = useProductosCarrito()

    const clickMenu = (it) => {

        iniciarChatWass({mensaje: 'Hola Cessa ' + it.nombre, numero: it.celular})

    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                borderBottom: '2px solid white',
            }}
        >

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 2}}
            >

                <Carrito/>

                <MenuPop opciones={[DIRECCIONLOCALES[0]]} click={clickMenu}/>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>
                            <img src={logo} width={170} height={'auto'} alt={"logo"} onClick={() => navigate('/Home')}
                                 style={{cursor: 'pointer'}}
                            />
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'flex-end'}}>
                            <Grid
                                container
                                justifyContent={'flex-end'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{px: 6}}
                                spacing={8}
                            >


                                {SECCIONES.map((item, index) => (
                                    <Typography
                                        onClick={() => ir(item)}
                                        sx={{
                                            fontSize: 16,
                                            color: '#fff',
                                            cursor: 'pointer',
                                            borderBottom: 1,
                                            fontWeight: 800,
                                            borderColor: '#ffffff00',
                                            transition: "all .2s ease-in-out",
                                            '&:hover': {
                                                borderColor: '#ffffff',
                                            }
                                        }}>{item}</Typography>
                                ))}

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-end'}}>

                            <Button
                                onClick={() => navigate('/Escuelas')}
                                color={'secondary'}
                                    startIcon={<img src={iso} style={{width: 24, height: 24, marginRight: 10}}/>}>Escuelas
                                de aprendizaje</Button>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default BarraPc



